import { IAnyStateTreeNode, types, getParent } from "mobx-state-tree";
import { Agent } from "../agent";
import { IAgent } from "../agent/Agent";
import { Guest, IGuest } from "../base/Guest";
import { IRoom } from "../room/Room";
import { usersStoreGetter } from "../utils";

export const AnyUserReferenceType = types.reference(types.union(Guest, Agent), {
  get(id: string, parent: IAnyStateTreeNode) {
    const client: IGuest = (getParent(parent, 3) as IRoom).owner;
    if (client.id === id) {
      return client;
    }
    return usersStoreGetter(parent).usersStore.getById(id);
  },
  set(value: IGuest | IAgent) {
    return (value && value.id) || "";
  }
});
